import * as React from "react"

import { ICharge } from "shared/hubrise/models"

import Delete from "./Delete"

const Commands = ({ charge }: { charge: ICharge }): JSX.Element => <Delete charge={charge} />

export default Commands
